import { PlatformId } from '@deltasierra/ids';
import { ServiceName } from '@deltasierra/integrations-integration-types';
import { HasId } from '../common';

// Re-exported to avoid a refactor
export { PlatformId };

export interface Platform extends HasId<PlatformId> {
    name: ServiceName;
    label: string;
    reporting: boolean;
    publishing: boolean;
    building: boolean;
    isLocationConfigurable: boolean;
}

export interface PlatformWithRequired extends Platform {
    required: boolean;
}

export type BasicPlatform = Pick<Platform, 'label' | 'name'>;

// TODO: merge ServiceName and PlatformIdentifier
export type PlatformIdentifier =
    | 'campaignMonitor'
    | 'clubReady'
    | 'facebook'
    | 'facebookMarketing'
    | 'fitware'
    | 'google'
    | 'googleAdWords'
    | 'googleMyBusiness'
    | 'instagram'
    | 'linkedIn'
    | 'twitter';
